
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'CategoryBoxComponent',
    props: {
        obj: {
            type: Object,
            required: true
        },
        image: {
            type: String,
            required: true
        }
    },
    methods: {
        itemImage(img: string) {
            const fileName = img.toLowerCase()
            return require(`@/assets/logos/${fileName}.png`)
        }
    },
})
